<script setup>
const emit = defineEmits(['reset']);

function handleEvents() {
  emit('reset');
}
</script>
<template>
  <div
    class="
      z-[1]
      py-12
      relative
      bg-white
      content-wrapper
      font-FordAntennaSemiBold
      text-center
      tracking-wider
      min-h-[17.25rem]
      tablet:text-xl
    "
  >
    No events match your search criteria
    <button
      class="block mt-4 mx-auto text-sm underline cursor-pointer"
      aria-label="See all events"
      @click.prevent="handleEvents"
    >
      View all events
    </button>
  </div>
</template>
